export const UPSCALE_FIAT_DEPOSIT = "UpscaleUSDDeposito";
export const UPSCALE_FIAT_WITHDRAW = "UpscaleUSDRetiro";

export const isUpscaleProcessorName = (name?: string) =>
  (name || "").toLowerCase().includes("upscale");

export const isUpscaleTransfer = (deposit: any) =>
  isUpscaleProcessorName(deposit?.systemProcessor?.name) ||
  isUpscaleProcessorName(deposit?.destinyProcessor?.name);

export const getUpscaleTransferType = (
  deposit: any
): "deposit" | "withdrawal" | "unknown" => {
  if (isUpscaleProcessorName(deposit?.destinyProcessor?.name)) return "deposit";
  if (isUpscaleProcessorName(deposit?.systemProcessor?.name)) return "withdrawal";
  return "unknown";
};

export const upscaleTransferTypeLabel = (type: string) => {
  switch (type) {
    case "deposit":
      return "Depósito";
    case "withdrawal":
      return "Retiro";
    default:
      return "Desconocido";
  }
};

export const upscaleStatusLabel = (status: string) => {
  switch (status) {
    case "waitpay":
      return "Esperando pago";
    case "checking":
      return "En verificación";
    case "completed":
      return "Completado";
    case "cancel":
      return "Cancelado";
    case "refused":
      return "Rechazado";
    default:
      return status;
  }
};

export const PENDING_UPSCALE_ADMIN_ENDPOINTS = [
  "GET /admin/upscale-transfer-list",
  "GET /admin/upscale-transfer-detail/:depositId",
  "POST /admin/upscale-payment-save",
  "GET /admin/upscale-balance-history",
];

export const upscaleEnvironmentLabel = (environment: string) =>
  environment === "production" ? "Producción" : environment === "testing" ? "Pruebas" : environment;

export const upscaleEnvironmentClass = (environment: string) =>
  environment === "production"
    ? "bg-emerald-100 text-emerald-800"
    : environment === "testing"
    ? "bg-orange-100 text-orange-800"
    : "bg-gray-100 text-gray-700";

export const upscaleMovementDirectionLabel = (direction?: string) =>
  direction === "credit" ? "Crédito" : direction === "debit" ? "Débito" : direction || "—";

export const isUpscaleBalanceNotFoundResponse = (payload: any) =>
  payload?.code === 102 || payload?.code === "102";

export const getUpscaleApiPayload = (responseOrError: any) =>
  responseOrError?.data ?? responseOrError?.response?.data ?? responseOrError;
